'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentBoardInboxState = exports.getCurrentBoard = exports.getIsBoardFetched = exports.getBoardResourceState = exports.getFetchedBoardIds = exports.getCurrentBoardError = exports.getIsCurrentBoardError = exports.getIsCurrentBoardFetched = exports.getIsCurrentBoardFetching = exports.getCurrentBoardResourceState = exports.currentBoardIdSelector = exports.boardResourcesSelector = undefined;

var _reselect = require('reselect');

var _resourceSelector = require('../../utils/services/http/resources/resourceSelector');

var _resourceUtil = require('../../utils/services/http/resources/resourceUtil');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _currentBoardIdSelector = require('../../reducers/currentBoardId/currentBoardIdSelector');

var _resourceConstants = require('../../utils/services/http/resources/resourceConstants');

// RESOURCES
// Lib
var boardResourcesSelector = exports.boardResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)(_resourceConstants.RESOURCE_TYPES.boards);

// Constants


// Utils
var currentBoardIdSelector = exports.currentBoardIdSelector = function currentBoardIdSelector(state, props) {
    return (0, _currentBoardIdSelector.getCurrentBoardId)(state) || props.currentBoardId || props.routeParams && props.routeParams.currentBoardId;
};

var getCurrentBoardResourceState = exports.getCurrentBoardResourceState = (0, _reselect.createSelector)(boardResourcesSelector, currentBoardIdSelector, function (boardResourcesState, currentBoardId) {
    return boardResourcesState.get(currentBoardId);
});

var getIsCurrentBoardFetching = exports.getIsCurrentBoardFetching = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isFetching);

var getIsCurrentBoardFetched = exports.getIsCurrentBoardFetched = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isFetched);

var getIsCurrentBoardError = exports.getIsCurrentBoardError = (0, _reselect.createSelector)(getCurrentBoardResourceState, _resourceUtil.isError);

var getCurrentBoardError = exports.getCurrentBoardError = (0, _reselect.createSelector)(getCurrentBoardResourceState, (0, _immutableHelper.prop)('error'));

var getFetchedBoardIds = exports.getFetchedBoardIds = (0, _reselect.createSelector)(boardResourcesSelector, function (boardResourcesState) {
    return (0, _immutableHelper.toIdArray)(boardResourcesState.filter(_resourceUtil.isFetched));
});

var getElementIdFromElement = function getElementIdFromElement(state, ownProps) {
    return ownProps.element && ownProps.element.get('id');
};

var getBoardResourceState = exports.getBoardResourceState = function getBoardResourceState(state, ownProps) {
    return boardResourcesSelector(state).get(getElementIdFromElement(state, ownProps));
};

var getIsBoardFetched = exports.getIsBoardFetched = function getIsBoardFetched(state, ownProps) {
    return (0, _resourceUtil.isFetched)(getBoardResourceState(state, ownProps));
};

// STATE
var getCurrentBoard = exports.getCurrentBoard = function getCurrentBoard(state, ownProps) {
    return state.getIn(['elements', currentBoardIdSelector(state)]);
};

var getCurrentBoardInboxState = exports.getCurrentBoardInboxState = function getCurrentBoardInboxState(state, ownProps) {
    var currentBoard = getCurrentBoard(state, ownProps);
    return currentBoard && currentBoard.getIn(['content', 'inbox']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardSelector.js
// module id = 83
// module chunks = 0